import { Box } from '@factorialco/deprecated-design-system'
import {
  DataTableFilter,
  FilterType,
  ProjectManagementProjectFilter,
} from 'generated/resources/datatable.graphql'
import { ContactForSelectFragment } from 'generated/resources/graphql'

import useFilter from 'modules/core/components/Filter/base/useFilter'
import i18n from 'modules/core/lib/i18n'

import { ContactSelector } from 'modules/finance/components/ContactSelector'

const ClientsFilterComponent = ({ companyId }: { companyId: number }) => {
  const { value, onValueChange } = useFilter<ContactForSelectFragment[]>()

  return (
    <Box flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <ContactSelector
        multiple
        value={value ?? []}
        onChange={onValueChange}
        companyId={companyId}
        hideBorder
        alwaysOpen
        label={''}
      />
    </Box>
  )
}

export const ClientFilter = (
  companyId: number
): DataTableFilter<ProjectManagementProjectFilter> => {
  return {
    type: FilterType.Entity,
    path: 'clientId',
    identifier: 'clientFilter',
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'legalName',
        component: () => <ClientsFilterComponent companyId={companyId} />,
      },
    ],
    title: i18n.t('project_management.table.projects_list.headers.client'),
  }
}
